import { formatCurrency } from "common/utils/currency"
import { nanoid } from "nanoid"
import { useTranslation } from "react-i18next"

const ModalVerDocumentoDatosBasicos = ({
  datosBasicosDocumento,
  document,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div className='tw-mb-3'>
      {datosBasicosDocumento?.map((dato: $TSMigrationFixMe) => {
        const nombreDelDato = dato[0]
        const valorDelDato = dato[1]

        return (
          <div
            key={nanoid()}
            className='tw-mb-2 tw-flex tw-justify-between'
          >
            <div className='tw-flex-shrink-0 '>
              <span className='tw-inline-block'>
                {formatCurrency(nombreDelDato)}
              </span>
            </div>

            <div className='tw-flex-grow tw-overflow-hidden tw-pl-6 tw-text-right tw-truncate'>
              <strong>{valorDelDato}</strong>
            </div>
          </div>
        )
      })}
      {document?.motivo && (
        <div className='tw-mb-2'>
          <p className='tw-py-0 tw-px-4 tw-truncate'>
            <strong>{t("crear.presupuesto.modal.rejectedLabel")}</strong>{" "}
            {document?.motivo}
          </p>
        </div>
      )}
    </div>
  )
}

export default ModalVerDocumentoDatosBasicos
